<template>
  <el-form status-icon :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" label-width="120px"
    v-loading="loading" class="carpo-form demo-ruleForm gap-y-6">
    <el-form-item :label="$t('GENDER')" prop="gender" v-loading="genderLoading">
      <el-select :disabled="ruleForm.disabled" filterable v-model="ruleForm.gender.id"
        :placeholder="$t('SELECT_PLACEHOLDER')">
        <el-option v-for="item in genderList" :key="item.id" :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
          :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('FIRST_NAME')" prop="first_name">
      <el-input :disabled="ruleForm.disabled" type="text" v-model="ruleForm.first_name" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item :label="$t('LAST_NAME')" prop="last_name">
      <el-input :disabled="ruleForm.disabled" type="text" v-model="ruleForm.last_name" autocomplete="off"></el-input>
    </el-form-item>

    <el-form-item :label="$t('FATHER_NAME')" prop="father_name">
      <el-input :disabled="ruleForm.disabled" type="text" v-model="ruleForm.father_name" autocomplete="off"></el-input>
    </el-form-item>
    <el-form-item :label="$t('BIRTHDAY')" prop="birthdate">
      <date-picker :disabled="ruleForm.disabled" color="#151515" class="el-input__inner" v-model="ruleForm.birthdate"
        view="year" format="jYYYY-jMM-jDD" max="1400/09/09" clearable :locale="$i18n.locale" />
    </el-form-item>
    <el-form-item :label="$t('NATIONAL_CODE')" prop="national_id">
      <el-input :disabled="ruleForm.disabled" type="text" @input="ruleForm.national_id = toEnglish(ruleForm.national_id)"
        v-model="ruleForm.national_id" autocomplete="off" class="left-inputs"></el-input>
    </el-form-item>
    <div class="hidden xl:flex xl:col-span-2"></div>
    <el-form-item :label="$t('DRIVING_LICENSE_TYPE')" prop="driving_license_type" v-loading="licenseLoading">
      <el-select :disabled="ruleForm.disabled" :placeholder="$t('SELECT_PLACEHOLDER')" multiple
        :collapse-tags="!ruleForm.disabled" clearable filterable v-model="ruleForm.driving_license_type">
        <el-option v-for="item in certificateList" :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('DRIVING_LICENSE_ID')" prop="driving_license_id">
      <el-input :disabled="ruleForm.disabled" type="text" @input="
        ruleForm.driving_license_id = toEnglish(ruleForm.driving_license_id)
      " v-model="ruleForm.driving_license_id" autocomplete="off" class="left-inputs"></el-input>
    </el-form-item>

    <el-form-item :label="$t('LICENSE_EXPIRY_DATE')" prop="driving_license_expiry_date">
      <date-picker :disabled="ruleForm.disabled" color="#151515" class="el-input__inner"
        v-model="ruleForm.driving_license_expiry_date" view="year" format="jYYYY-jMM-jDD" clearable
        :locale="$i18n.locale" />
    </el-form-item>
    <el-form-item :label="$t('NON_ADDICTION')" prop="has_certificate_of_non_addiction">
      <el-select :disabled="ruleForm.disabled" filterable v-model="ruleForm.has_certificate_of_non_addiction"
        :placeholder="$t('SELECT_PLACEHOLDER')">
        <el-option v-for="item in addictedList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('SMART_CARD')" prop="has_smart_card">
      <el-select :disabled="ruleForm.disabled" filterable v-model="ruleForm.has_smart_card"
        :placeholder="$t('SELECT_PLACEHOLDER')">
        <el-option v-for="item in addictedList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('HEALTH_LICESNCE_ID')" prop="health_license_id">
      <el-input :disabled="ruleForm.disabled" type="text" @input="
        ruleForm.health_license_id = toEnglish(ruleForm.health_license_id)
      " v-model="ruleForm.health_license_id" autocomplete="off" class="left-inputs"></el-input>
    </el-form-item>
    <el-form-item :label="$t('HEALTH_LICESNCE_EXPIRY_DATE')" prop="health_license_expiry_date">
      <date-picker :disabled="ruleForm.disabled" color="#151515" class="el-input__inner"
        v-model="ruleForm.health_license_expiry_date" view="year" format="jYYYY-jMM-jDD" clearable
        :locale="$i18n.locale" />
    </el-form-item>

    <el-form-item :label="$t('BLOOD_TYPE')" prop="blood_type" v-loading="bloodLoading">
      <el-select :disabled="ruleForm.disabled" clearable filterable v-model="ruleForm.blood_type.id"
        :placeholder="$t('SELECT_PLACEHOLDER')">
        <el-option v-for="item in bloodList" :key="item.id" :label="item.title" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('CREDIT_CARD_NUMBER')" prop="credit_card_number">
      <el-input :disabled="ruleForm.disabled" type="text" @input="
        ruleForm.credit_card_number = toEnglish(ruleForm.credit_card_number)
      " v-model="ruleForm.credit_card_number" autocomplete="off" class="left-inputs" clearable></el-input>
    </el-form-item>
    <el-form-item :label="$t('MARITAL_STATUS')" prop="marriage" v-loading="maritalLoading">
      <el-select :disabled="ruleForm.disabled" clearable filterable v-model="ruleForm.marital_status.id"
        :placeholder="$t('SELECT_PLACEHOLDER')">
        <el-option v-for="item in marriageList" :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('NUMBER_OF_CHILDREN')" prop="number_of_children">
      <el-select :disabled="ruleForm.disabled" clearable filterable v-model="ruleForm.number_of_children"
        :placeholder="$t('SELECT_PLACEHOLDER')">
        <el-option v-for="item in childCount" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item :label="$t('EDUCATION')" prop="education" v-loading="educationLoading">
      <el-select :disabled="ruleForm.disabled" clearable filterable v-model="ruleForm.education.id"
        :placeholder="$t('SELECT_PLACEHOLDER')">
        <el-option v-for="item in educationList" :key="item.id"
          :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="flex justify-end col-span-full mt-4">
      <slot> </slot>
      <el-button type="success" @click="submitForm('ruleForm')">
        {{ $t("NEXT_FORM") }}
      </el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { resetForm } from "@/mixins/resetForm";
import { driverLicensetypes, driverGenders, driverEducation, driverMartial, driverBlood } from "@/api/drivers";

export default {
  props: ["ruleForm", "loading"],
  mixins: [resetForm],
  data() {
    var nationalCheck = (rule, value, callback) => {
      var strongRegex = new RegExp("^[\u06F0-\u06F90-9]{10}$");

      if (!strongRegex.test(value))
        return callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", {
              type: this.$i18n.t("NATIONAL_CODE"),
            })
          )
        );
      const check = +value[9];
      const sum =
        value
          .split("")
          .slice(0, 9)
          .map((x, i) => +x * (10 - i))
          .reduce((x, y) => x + y) % 11;
      if (sum < 2 ? check == sum : check + sum == 11) {
        callback();
      } else {
        callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", {
              type: this.$i18n.t("NATIONAL_CODE"),
            })
          )
        );
      }
    };
    var checkMobile = (rule, value, callback) => {
      var strongRegex = new RegExp(
        "^(\\+98|0)?9\\d{9}|۰۹[\u06F0-\u06F90-9]{9}$"
      );
      if (strongRegex.test(value)) {
        callback();
      } else {
        callback(
          new Error(
            this.$i18n.t("INVALID_FIELD", {
              type: this.$i18n.t("MOBILE"),
            })
          )
        );
      }
    };
    var checkBank = (rule, value, callback) => {
      if (value != "" && value != undefined && value != null) {
        if (value != undefined) {
          callback();
        }
        if (value.length !== 16) {
          callback(
            new Error(
              this.$i18n.t("INVALID_FIELD", {
                type: this.$i18n.t("CREDIT_CARD_NUMBER"),
              })
            )
          );
        }
        let cardTotal = 0;
        for (let i = 0; i < 16; i += 1) {
          const c = Number(value[i]);
          if (i % 2 === 0) {
            cardTotal += c * 2 > 9 ? c * 2 - 9 : c * 2;
          } else {
            cardTotal += c;
          }
        }
        if (cardTotal % 10 === 0) {
          callback();
        } else {
          callback(
            new Error(
              this.$i18n.t("INVALID_FIELD", {
                type: this.$i18n.t("CREDIT_CARD_NUMBER"),
              })
            )
          );
        }
      } else {
        callback();
      }
    };
    return {
      date: "",
      active: 0,
      licenseLoading: true,
      genderLoading: true,
      maritalLoading: true,
      educationLoading: true,
      bloodLoading: true,
      genderList: [],
      marriageList: [],
      educationList: [],
      bloodList: [],
      childCount: [
        {
          value: 0,
          label: this.$i18n.t("NO_CHILDREN"),
        },
        {
          value: 1,
          label: "۱",
        },
        {
          value: 2,
          label: "۲",
        },
        {
          value: 3,
          label: "۳",
        },
        {
          value: 4,
          label: this.$i18n.t("MORE_THAN_THREE"),
        },
      ],

      certificateList: [
        {
          en_title: "",
          fa_title: "",
          id: 1,
        },
      ],

      addictedList: [
        {
          value: true,
          label: this.$i18n.t("PROVIDED"),
        },
        {
          value: false,
          label: this.$i18n.t("NOT_PROVIDED"),
        },
      ],

      rules: {
        gender: [
          {
            required: true,
            trigger: "blur",
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("GENDER"),
            }),
          },
        ],
        first_name: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("FIRST_NAME"),
            }),
            trigger: "blur",
          },
        ],
        last_name: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("LAST_NAME"),
            }),
            trigger: "blur",
          },
        ],
        father_name: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_FIELD", {
              type: this.$i18n.t("FATHER_NAME"),
            }),
            trigger: "blur",
          },
        ],
        birthdate: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("BIRTHDAY"),
            }),
            trigger: "blur",
          },
        ],
        national_id: [
          {
            required: true,
            trigger: "blur",
            validator: nationalCheck,
          },
        ],
        driving_license_type: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("DRIVING_LICENSE_TYPE"),
            }),
            trigger: "blur",
          },
        ],
        has_certificate_of_non_addiction: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("NON_ADDICTION"),
            }),
            trigger: "blur",
          },
        ],
        has_smart_card: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("SMART_CARD"),
            }),
            trigger: "blur",
          },
        ],

        driving_license_id: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("DRIVING_LICENSE_ID"),
            }),
            trigger: "blur",
          },
        ],
        driving_license_expiry_date: [
          {
            required: true,
            message: this.$i18n.t("REQUIRED_CHOOSE", {
              type: this.$i18n.t("LICENSE_EXPIRY_DATE"),
            }),
            trigger: "blur",
          },
        ],

        // health_license_expiry_date: [
        //   {
        //     required: false,
        //     message: "وارد کردن تاریخ انقضای سلامت اجباری است",
        //     trigger: "blur",
        //   },
        // ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            validator: checkMobile,
          },
        ],

        credit_card_number: [
          {
            required: false,
            trigger: "blur",
            validator: checkBank,
          },
        ],
      },
    };
  },
  methods: {
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$refs[form].clearValidate();
          this.$emit("next", true);
          this.$emit("ruleForm", this.ruleForm);
        } else {
          this.$notify.error({
            title: this.$i18n.t("FIXED_ERRORS", {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: "error_msg",
          });
          return false;
        }
      });
    },
  },
  mounted() {
    driverLicensetypes.api().then((res) => {
      if (res) {
        this.certificateList = res;
        this.licenseLoading = false;
      }
    });

    driverGenders.api().then((res) => {
      if (res) {
        this.genderList = res;
        this.genderLoading = false;
      }
    });
    driverEducation.api().then((res) => {
      if (res) {
        this.educationList = res;
        this.educationLoading = false;
      }
    });
    driverMartial.api().then((res) => {
      if (res) {
        this.marriageList = res;
        this.maritalLoading = false;
      }
    });
    driverBlood.api().then((res) => {
      if (res) {
        this.bloodList = res;
        this.bloodLoading = false;
      }
    });
  },
};
</script>
